
export const isLocal = process.env.NODE_ENV === 'development'